import React, { useState } from "react";
import { connect } from "react-redux";
import "./SecuriteDonnees.css";
import FeuilleAcces from "./FeuilleAcces";
import Utilisateur from "./UserAcces";
import Doss from "./Fiche-doss";




const SecuriteDonnees = ({ Auth, darck, InfoDossier }) => {
  const dossier = InfoDossier?.[0]?.coddos || "inconnu";
  const utilisateur = Auth?.username || "admin";

  const [showAcces, setShowAcces] = useState(false);
  const [showuser, setShowUser] = useState(false);
  const [showdoss, setShowDoss] = useState(false);
  // 🔐 password modal
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");

  // 🔥 Vérification mot de passe
  const handleVerifyPassword = () => {
    if (passwordInput === "polysoftahmedmezgani") {
      setShowAcces(true);
      setShowPasswordModal(false);
      setPasswordInput("");
    } else {
      alert("Mot de passe incorrect !");
    }
  };

  return (
    <>
      {/* 🔥 OVERLAY ACCES */}
      {showAcces && (
        <div className="overlay">
          <FeuilleAcces onClose={() => setShowAcces(false)} />
        </div>
      )}

      {/* 🔥 OVERLAY USER */}
      {showuser && (
        <div className="overlay">
          <Utilisateur onClose={() => setShowUser(false)} />
        </div>
      )}
     {showdoss&& (
        <div className="overlay">
          <Doss onClose={() => setShowDoss(false)} />
        </div>
      )}
      {/* 🔐 MODAL PASSWORD */}
      {showPasswordModal && (
        <div className="overlay">
          <div className="password-modal">
            <h4>🔐 Vérification</h4>

            <input
              type="password"
              placeholder="Entrez le mot de passe"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
            />

            <div className="actions">
              <button onClick={handleVerifyPassword}>Valider</button>
              <button onClick={() => setShowPasswordModal(false)}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PAGE PRINCIPALE */}
      <div
        className={`securite-container ${darck ? "dark-mode" : ""}`}
        style={{
          filter: showAcces || showuser || showPasswordModal ? "blur(2px)" : "none",
        }}
      >
        <h3 className="securite-title">Sécurité des Données</h3>

        <div className="securite-info">
          <div>
            Dossier En Cours : <b>{dossier}</b>
          </div>
          <div>
            Utilisateur En Cours : <b>{utilisateur}</b>
          </div>
        </div>

        <div className="securite-grid">
          <button>Fichier Dossier</button>
          {/* <button>Sauvegarde</button> */}
          <button>Groupes</button>

          <button onClick={() => setShowUser(true)}>
          Accès Utilisateurs
            {/* Utilisateurs */}
          </button>

          {/* 🔥 BOUTON AVEC PASSWORD */}
          <button onClick={() => setShowPasswordModal(true)}>
          Paramétrage
          </button>
          {/* <button onClick={() => setShowDoss(true)}>Paramètre Fiche Dossier </button> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  Auth: state.Auth,
  darck: state.darck.darck,
  InfoDossier: state.InfoDossier,
});

export default connect(mapStateToProps)(SecuriteDonnees);
















// import React, { useState } from "react";
// import { connect } from "react-redux";
// import "./SecuriteDonnees.css";
// import FeuilleAcces from "./FeuilleAcces";
// import Utilisateur from "../personnels/UsersForm";
// const SecuriteDonnees = ({ Auth, darck, InfoDossier }) => {
//   const dossier = InfoDossier?.[0]?.coddos || "inconnu";
//   const utilisateur = Auth?.username || "admin";

//   const [showAcces, setShowAcces] = useState(false);
//   const [showuser, setShowUser] = useState(false);
//   return (
//     <>
//       {/* 🔥 OVERLAY */}
//       {showAcces && (
//         <div className="overlay">
//           <FeuilleAcces onClose={() => setShowAcces(false)} />
//         </div>
//       )}
//        {showuser && (
//         <div className="overlay">
//           <Utilisateur onClose={() => setShowUser(false)} />
//         </div>
//       )}

//       {/* PAGE SÉCURITÉ EN BACKGROUND */}
//       <div
//         className={`securite-container ${darck ? "dark-mode" : ""}`}
//         style={{ filter: showAcces ? "blur(2px)" : "none" }}
//       >
//         <h3 className="securite-title">Sécurité des Données</h3>

//         <div className="securite-info">
//           <div>Dossier En Cours : <b>{dossier}</b></div>
//           <div>Utilisateur En Cours : <b>{utilisateur}</b></div>
//         </div>

//         <div className="securite-grid">
//           <button>Fichier Dossier</button>
//           <button>Sauvegarde</button>
//           <button>Groupes</button>
//           <button onClick={() => setShowUser(true)}> Utilisateurs</button>

//           {/* ✅ OUVERTURE PAGE ACCÈS */}
//           <button onClick={() => setShowAcces(true)}>
//             Accès Utilisateurs
//           </button>

//           {/* <button>Ma Facture</button> */}
//           {/* <button>Restauration</button> */}
//           {/* <button>Clôture / Ouverture Mois</button> */}
//           {/* <button>Corriger Recherche</button> */}
//           {/* <button>Paramétrage Venus</button> */}
//           {/* <button>Actualiser les Menus</button> */}
//         </div>
//       </div>
//     </>
//   );
// };

// const mapStateToProps = (state) => ({
//   Auth: state.Auth,
//   darck: state.darck.darck,
//   InfoDossier: state.InfoDossier,
// });

// export default connect(mapStateToProps)(SecuriteDonnees);



// import React, { useState } from "react";
// import { connect } from "react-redux";
// import "./SecuriteDonnees.css";
// import FeuilleAcces from "./FeuilleAcces"; // <-- importer

// const SecuriteDonnees = ({ Auth, darck, InfoDossier }) => {
//   const dossier = InfoDossier?.[0]?.coddos || "inconnu";
//   const utilisateur = Auth?.username || "admin";

//   const [showAcces, setShowAcces] = useState(false);

//   // 👉 Si on veut afficher la feuille des accès
//   if (showAcces) {
//     return <FeuilleAcces onClose={() => setShowAcces(false)} />;
//   }

//   return (
//     <div className={`securite-container ${darck ? "dark-mode" : ""}`}>
//       <h3 className="securite-title">Sécurité des Données</h3>

//       <div className="securite-info">
//         <div>Dossier En Cours : <b>{dossier}</b></div>
//         <div>Utilisateur En Cours : <b>{utilisateur}</b></div>
//       </div>

//       <div className="securite-grid">
//         <button>MAJ Dossier</button>
//         <button>Sauvegarde</button>
//         <button>Groupes</button>
//         <button>Utilisateurs</button>

//         {/* 🔥 BOUTON IMPORTANT */}
//         <button onClick={() => setShowAcces(true)}>
//           Accès Utilisateurs
//         </button>

//         <button>Ma Facture</button>
//         <button>Restauration</button>
//         <button>Clôture / Ouverture Mois</button>
//         <button>Corriger Recherche</button>
//         <button>Paramétrage Venus</button>
//         <button>Actualiser les Menus</button>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => ({
//   Auth: state.Auth,
//   darck: state.darck.darck,
//   InfoDossier: state.InfoDossier,
// });

// export default connect(mapStateToProps)(SecuriteDonnees);





// import React from "react";
// import { connect } from "react-redux";
// import "./SecuriteDonnees.css";

// const SecuriteDonnees = ({ Auth, darck, InfoDossier }) => {
//   const dossier = InfoDossier?.[0]?.coddos || "inconnu";
//   const utilisateur = Auth?.username || "admin";

//   return (
//     <div className={`securite-container ${darck ? "dark-mode" : ""}`}>
//       <h3 className="securite-title">Sécurité des Données</h3>

//       <div className="securite-info">
//         <div>Dossier En Cours : <b>{dossier}</b></div>
//         <div>Utilisateur En Cours : <b>{utilisateur}</b></div>
//       </div>

//       <div className="securite-grid">
//         <button>MAJ Dossier </button>
//         <button>Sauvegarde </button>
//         <button>Groupes </button>
//         <button>Utilisateurs </button>
//         <button>Accès Utilisateurs </button>
//         <button>Ma Facture </button>
//         <button>Restauration </button>
//         <button>Clôture / Ouverture Mois </button>
//         <button>Corriger Recherche</button>
//         <button>Paramétrage Venus</button>
//         <button>Actualiser les Menus</button>
      
//       </div>
//     </div>
//   );
// };

// // Connexion à Redux
// const mapStateToProps = (state) => ({
//   Auth: state.Auth,
//   darck: state.darck.darck,
//   InfoDossier: state.InfoDossier,
// });

// export default connect(mapStateToProps)(SecuriteDonnees);
